import { useMemo } from "react";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { getAllTokenClaims, getUserIdFromToken } from "../utils/jwt";

/**
 * Custom hook to access JWT token information.
 * The returned values are memoized on `token` so `claims`/`userId` are referentially stable across
 * renders and safe to use in effect/callback dependency arrays.
 * @returns Object with token information and utility functions
 */
export function useTokenInfo() {
  const auth = useSelector(authorizeSelectors.auth);
  const token = auth?.token;

  return useMemo(
    () => ({
      claims: getAllTokenClaims(token),
      userId: getUserIdFromToken(token),
      token,
    }),
    [token],
  );
}
